var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade" } },
    [
      _vm.notes
        ? _c(
            "base-card",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _c("h3", { staticClass: "d-inline-block mr-2" }, [
                          _vm._v(_vm._s(_vm.$t("menu.notes")))
                        ]),
                        _vm._v(" "),
                        !_vm.readonly && _vm.notes.patientNotes.lastUpdate
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "d-inline-block",
                                attrs: { pill: "", variant: "light" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("appointment-notes.last-update") +
                                      " " +
                                      _vm.lastUpdate
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2754932109
              )
            },
            [
              _vm._v(" "),
              _c(
                _vm.readonly ? "div" : "delayed-input-delegate",
                { tag: "component", on: { delayedInput: _vm.saveNotes } },
                [
                  _c("base-textarea", {
                    attrs: {
                      label: _vm.$t("appointment-notes.notes"),
                      placeholder: _vm.$t("appointment-notes.write-here")
                    },
                    model: {
                      value: _vm.notes.notes,
                      callback: function($$v) {
                        _vm.$set(_vm.notes, "notes", $$v)
                      },
                      expression: "notes.notes"
                    }
                  }),
                  _vm._v(" "),
                  _c("base-textarea", {
                    attrs: {
                      label: _vm.$t("appointment-notes.patientNotes"),
                      description: _vm.$t(
                        "appointment-notes.invisible-for-patient"
                      ),
                      placeholder: _vm.$t("appointment-notes.write-here")
                    },
                    model: {
                      value: _vm.notes.patientNotes.text,
                      callback: function($$v) {
                        _vm.$set(_vm.notes.patientNotes, "text", $$v)
                      },
                      expression: "notes.patientNotes.text"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcfab9e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcfab9e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AppointmentNotes.vue
// module id = 3605
// module chunks = 29